/* eslint-disable react/prop-types */
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Popup } from "..";
import LoginImg from ".././../../../../assets/images/nl-images/subscriptionstaticpage.png";

import { useSelector } from "react-redux";
import { getAuthUrl } from "../../../helper/hooks";
import "./subscribe-popup.m.css";

export const SubscribePopup = props => {
  const loginUrl = getAuthUrl();

  const redirectRef =
    props.source && props.source === "podcast-page"
      ? "podcast-popup"
      : "comment-popup";

  const { fetchSubscription, member } = useSelector(state => state);

  const pushToDataLayer = (event, action) => {
    const obj = {
      event: event,
      paywall_content_name: window.location.href,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    if (action) {
      obj.paywall_user_action = action;
    }

    window.dataLayer.push(obj);
  };

  useEffect(() => {
    pushToDataLayer("popup_paywall");
  }, []);

  return (
    <Popup
      showModal={props.showModal}
      setShowModal={props.setShowModal}
      // hideCloseIcon={props.hideCloseIcon}
    >
      <div styleName="subscribe-content-wrapper">
        <img src={assetify(LoginImg)} />
        <h2>Oops! This is available for subscriber only</h2>
        <p>
          Subscribe now to power our ad-free, independent journalism. Pay to
          keep news free
        </p>
        <Link href={`/subscription?ref=${redirectRef}`}>
          <button
            onClick={() =>
              pushToDataLayer("popup_paywall_user_action", "subscribe")
            }
          >
            Subscribe
          </button>
        </Link>
        <small>
          Already a subscriber?{" "}
          <span
            onClick={() =>
              pushToDataLayer("popup_paywall_user_action", "login")
            }
          >
            <Link href={loginUrl}>Login</Link>
          </span>
        </small>
      </div>
    </Popup>
  );
};

SubscribePopup.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func
};
